import { promiseAction } from 'utils/store';

export const CONTENT_ACTION_TYPES = {
  CREATE_PUBLICATION: 'content/CREATE_PUBLICATION',
};

export const createPublication = promiseAction(CONTENT_ACTION_TYPES.CREATE_PUBLICATION)
